import { Component, Input, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '@environment';
import { MailComponentService } from '../services/mail-component.service';
import { MailMessage, MailThreadMessage } from '../types';
import { provideTranslation } from '@skyeng/libs/shared/i18n';

@Component({
  selector: 'crm-mail-message',
  templateUrl: './mail-message.component.html',
  styleUrls: ['./mail-message.component.scss'],
  viewProviders: [provideTranslation('mailMessage', () => import.meta.webpackContext!('./translation'))],
})
export class MailMessageComponent implements OnInit {
  @Input() threadMessage: MailThreadMessage;

  @Input() set alwaysExpanded(value: boolean) {
    this.isMessageExpanded = value || false;
    this._alwaysExpanded = value || false;
  }

  get alwaysExpanded(): boolean {
    return this._alwaysExpanded;
  }

  private _alwaysExpanded: boolean;

  mailMessage$: Observable<MailMessage>;
  isMessageExpanded = false;
  isReplyExpanded = false;

  readonly baseEndpoint = environment.crm.backend.baseEndpoint;

  constructor(private mailPage: MailComponentService) {}

  ngOnInit(): void {
    this.getMessage();
  }

  toggleMessage(): void {
    if (this._alwaysExpanded) {
      return;
    }

    this.isMessageExpanded = !this.isMessageExpanded;

    if (this.isMessageExpanded) {
      this.loadMessage();
    }
  }

  toggleReply(): void {
    this.isReplyExpanded = !this.isReplyExpanded;
  }

  markAsRead(): void {
    this.mailPage.markMessageAsRead(this.threadMessage.id);
  }

  private getMessage(): void {
    this.mailMessage$ = this.mailPage.getMessage(this.threadMessage.id);

    if (this._alwaysExpanded) {
      this.loadMessage();
    }
  }

  private loadMessage(): void {
    this.mailPage.loadMessage(this.threadMessage.id);
  }
}
